export default __webpack_public_path__ + "static/media/error.826ad885.svg";